module.exports = __webpack_public_path__ + "static/media/icon-3.f9d0b494.png";